import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import httpClient from '../http/HttpRequest';
import { GET_STUDENT } from '../data/url';
import { checkToken } from '../utils/Auth';

const StudentContext = createContext();

export const useStudentContext = () => {
    return useContext(StudentContext);
};

export const StudentProvider = ({ children }) => {
    const [studentData, setStudentData] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        if (checkToken()) {
            getStudent();
        }
    }, []);

    const getStudent = async () => {
        try {
            const res = await httpClient.post(GET_STUDENT, {});
            if (res.requestStatus === 'OK' && res.result.status === 1) {
                setStudentData(res.result.data);
            } else {
                localStorage.removeItem('token'); 
                navigate('/login'); 
            }
        } catch (error) {
            console.error('User error:', error);
        }
    };

    const updateStudentData = async () => {
        getStudent();
    };

    return (
        <StudentContext.Provider value={{ studentData, updateStudentData }}>
            {children}
        </StudentContext.Provider>
    );
};
